import { useConfirm } from 'material-ui-confirm'
import React, { useEffect, useState } from 'react'
import { Meteor } from 'meteor/meteor'
import { FormattedMessage, useIntl } from 'react-intl'
import { toast } from 'react-toastify'

import makeStyles from '@material-ui/styles/makeStyles'
import { Card, CardContent, Typography } from '@material-ui/core'

import Button from '../components/Button'
import PaymentOption, {
  clientSecretStripe,
  elementsInstance,
  stripeInstance,
} from '../components/PaymentOption'
import { paymentOptionsInit } from '../components/PaymentSection'

import { CONTRACT_PAYMENT_TYPE } from '../schema/contracts'

const useStyle = makeStyles({
  subTitle: {
    marginTop: 16,
    marginBottom: 16,
    fontWeight: 'bold',
  },
})

const MyPaymentMethod: React.FC = () => {
  const [paymentOptions, setPaymentOptions] = useState([])
  const [selectedOption, setSelectedOption] = useState(null)

  const confirm = useConfirm()
  const classes = useStyle()
  const { formatMessage } = useIntl()

  useEffect(() => {
    fetchData()
  }, [])

  const handleAdd = async () => {
    try {
      let result
      if (selectedOption.id === 'ADD_CB') {
        result = await stripeInstance.confirmCardSetup(clientSecretStripe, {
          payment_method: {
            card: elementsInstance.getElement('card'),
          },
        })
      } else if (selectedOption.id === 'ADD_IBAN') {
        const user = Meteor.user()

        result = await stripeInstance.confirmSepaDebitSetup(clientSecretStripe, {
          payment_method: {
            sepa_debit: elementsInstance.getElement('iban'),
            billing_details: {
              name: user.profile.name,
              email: user.emails?.[0]?.address || 'contact@callalawyer.fr',
              address: {
                line1: user.profile.address,
                country: 'fr',
              },
            },
          },
        })
      }

      await Meteor.promise('setPaymentTypePref', {
        id: result.setupIntent.payment_method,
        updateSubscriptionPaymentMethod: true,
      })

      setSelectedOption(null)
      fetchData()
    } catch (e) {
      toast.error(e.message || JSON.stringify(e))
    }
  }

  const fetchData = async () => {
    const paymentOptionsInserted = []
    const cards = await Meteor.promise('listCards')

    const bankAccounts = await Meteor.promise('listBankAccounts')

    cards.forEach((card) => {
      paymentOptionsInserted.push({
        id: card.id,
        CardId: card.id,
        name: `Carte de crédit ${card.alias}`,
        type: CONTRACT_PAYMENT_TYPE.CB,
        logos: [],
        detailledView: false,
      })
    })
    bankAccounts.forEach((bankAccount) => {
      paymentOptionsInserted.push({
        id: bankAccount.id,
        name: `SEPA se terminant par ${bankAccount.alias}`,
        type: CONTRACT_PAYMENT_TYPE.SEPA,
        logos: [],
        detailledView: false,
      })
    })

    setPaymentOptions(paymentOptionsInserted)
  }

  const handleDelete = async ({ id }) => {
    confirm().then(() => {
      Meteor.promise('deleteCard', { cardId: id })
        .then(() => {
          toast.success(formatMessage({ id: 'success', defaultMessage: 'Opération réussie.' }))
          fetchData()
        })
        .catch(() => {
          toast.error(formatMessage({ id: 'error' }))
        })
    })
  }

  return (
    <Card>
      <CardContent>
        <Typography className={classes.subTitle}>
          <FormattedMessage
            id={'MyPaymentMethod.MyPaymentMethod'}
            defaultMessage={'Mes moyens de paiement enregistrés:'}
          />
        </Typography>
        <div>
          {paymentOptions.map((option) => (
            <PaymentOption key={option.id} option={option} onDelete={() => handleDelete(option)} />
          ))}
        </div>

        <Typography className={classes.subTitle}>Ajoutez un moyen de paiement:</Typography>
        {paymentOptionsInit.map((option) => (
          <PaymentOption
            key={option.name}
            option={option}
            selectedOption={selectedOption}
            onClickRadio={() => setSelectedOption(option)}
          />
        ))}

        <Button color={'secondary'} onClick={handleAdd} disabled={!selectedOption}>
          <FormattedMessage
            id={'MyPaymentMethod.Add'}
            defaultMessage={'Ajouter ce moyen de paiement'}
          />
        </Button>
      </CardContent>
    </Card>
  )
}

export default MyPaymentMethod
